import { BUSINESS_INFO, CONTACT_INFO } from '@/shared/config/info';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/shared/ui/dialog';
import { ScrollArea } from '@/shared/ui/scroll-area';
import { DialogDescription } from '@radix-ui/react-dialog';

export default function Footer() {
  const privacyImages = Array.from({ length: 7 }, (_, i) => `/images/policy/privacy/${i + 1}.webp`);

  const serviceImages = Array.from({ length: 14 }, (_, i) => `/images/policy/service/${i + 1}.webp`);

  return (
    <footer
      className='w-full px-4 py-8'
      style={{
        background: 'var(--bs-paper-alt)',
        borderTop: '1px solid var(--bs-line-soft)',
      }}
    >
      <div className='max-w-7xl mx-auto'>
        <div className='flex flex-col md:flex-row justify-between items-center md:items-start gap-8'>
          {/* Left Side — 브랜드 로고 (Fraunces 텍스트 트리트먼트) */}
          <div className='flex flex-col items-center md:items-start md:w-1/5 w-3/5'>
            <div
              className='mb-3 text-[28px] md:text-[32px] leading-none font-semibold italic'
              style={{
                fontFamily: 'var(--bs-font-serif)',
                color: 'var(--bs-ink)',
                letterSpacing: '-0.025em',
              }}
            >
              Before <span style={{ color: 'var(--bs-accent)' }}>Somerise.</span>
            </div>
            <p
              className='text-center md:text-left text-[13px] leading-[1.6]'
              style={{
                color: 'var(--bs-ink-soft)',
                letterSpacing: '-0.01em',
              }}
            >
              프리미엄 로테이션 소개팅.
              <br />
              처음 마주 앉는 자리를 만듭니다.
            </p>
          </div>

          {/* Right Side - Business Info */}
          <div className='flex flex-col md:items-end text-sm md:w-3/5 md:pl-8'>
            <div className='grid grid-cols-1 gap-2 text-center md:text-right'>
              <p
                className='text-sm'
                style={{ color: 'var(--bs-ink-soft)' }}
              >위치: {BUSINESS_INFO.location}</p>
              <p
                className='text-sm'
                style={{ color: 'var(--bs-ink-soft)' }}
              >사업자 등록번호: {BUSINESS_INFO.registrationNumber}</p>
              <p
                className='text-sm'
                style={{ color: 'var(--bs-ink-soft)' }}
              >대표자: {BUSINESS_INFO.representative}</p>
              <div className='flex items-center justify-center md:justify-end gap-2'>
                <p
                className='text-sm'
                style={{ color: 'var(--bs-ink-soft)' }}
              >인스타그램:</p>
                <a
                  href={CONTACT_INFO.instagram.url}
                  className='transition-colors hover:opacity-80'
                  style={{ color: 'var(--bs-accent)' }}
                >
                  {CONTACT_INFO.instagram.id}
                </a>
              </div>
              <div className='flex items-center justify-center md:justify-end gap-2'>
                <p
                className='text-sm'
                style={{ color: 'var(--bs-ink-soft)' }}
              >이메일:</p>
                <a
                  href={`mailto:${CONTACT_INFO.email}`}
                  className='transition-colors hover:opacity-80'
                  style={{ color: 'var(--bs-accent)' }}
                >
                  {CONTACT_INFO.email}
                </a>
              </div>
              <div className='flex items-center justify-center md:justify-end gap-2'>
                <p
                  className='text-sm'
                  style={{ color: 'var(--bs-ink-soft)' }}
                >
                  전화:
                </p>
                <a
                  href={`tel:${CONTACT_INFO.phone.replace(/-/g, '')}`}
                  className='transition-colors hover:opacity-80'
                  style={{ color: 'var(--bs-accent)' }}
                >
                  {CONTACT_INFO.phone}
                </a>
              </div>
            </div>

            {/* Links */}
            <div
              className='mt-6 flex justify-center space-x-4 pt-4 md:justify-end'
              style={{ borderTop: '1px solid var(--bs-line-soft)' }}
            >
              <Dialog>
                <DialogTrigger asChild>
                  <button
                    className='underline-offset-2 transition-colors hover:underline hover:opacity-80'
                    style={{ color: 'var(--bs-ink-mute)' }}
                  >개인정보처리방침</button>
                </DialogTrigger>
                <DialogContent className='max-w-4xl max-h-[90vh]'>
                  <DialogHeader>
                    <DialogTitle>개인정보처리방침</DialogTitle>
                  </DialogHeader>
                  <DialogDescription className='sr-only'>개인정보처리방침</DialogDescription>
                  <ScrollArea className='h-[70vh] w-full'>
                    <div className='space-y-0'>
                      {privacyImages.map((src, index) => (
                        <img key={index} src={src} alt={`이용약관 ${index + 1}페이지`} className='w-full h-auto' />
                      ))}
                    </div>
                  </ScrollArea>
                </DialogContent>
              </Dialog>
              <Dialog>
                <DialogTrigger asChild>
                  <button
                    className='underline-offset-2 transition-colors hover:underline hover:opacity-80'
                    style={{ color: 'var(--bs-ink-mute)' }}
                  >이용약관</button>
                </DialogTrigger>
                <DialogContent className='max-w-4xl max-h-[90vh]'>
                  <DialogHeader>
                    <DialogTitle>이용약관</DialogTitle>
                  </DialogHeader>
                  <DialogDescription className='sr-only'>이용약관</DialogDescription>
                  <ScrollArea className='h-[70vh] w-full'>
                    <div className='space-y-0'>
                      {serviceImages.map((src, index) => (
                        <img key={index} src={src} alt={`이용약관 ${index + 1}페이지`} className='w-full h-auto' />
                      ))}
                    </div>
                  </ScrollArea>
                </DialogContent>
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
